import icAddSquare from "assets/images/id-add-square.svg"
import Button from "components/commons/button"
import DeleteModal from "components/commons/delete-modal"
import FormModal from "components/commons/form-modal"
import Input from "components/commons/input"
import Select from "components/commons/select"
import Table from "components/commons/table"
import {ACTION_TYPE} from "../../../constants/constant";
import ErrorMessage from "../../commons/error-message";
import Toast from "../../commons/toast";
import ViewList from "../../commons/view-list";
import {
    FilterContainer
} from "../../../containers/general-settings/overtime-setting/benefit-representative/FilterContainer";

export const BenefitsRepresentative = (
    {
        configTable,
        dataBenefitRepresentative,
        query,
        options,
        form,
        modal,
        actionType,
        errorForm,
        isShowToast,
        toastMessage,
        queryFilter,
        clearToast,
        onChangeQuery,
        onActionRow,
        onDelete,
        onSetModal,
        onChangeForm,
        onSubmitForm,
        isLoadingTable,
        isCreating,
        isUpdating,
        isDeleting,
    }) => {

    return (
        <>
            <div className="font-semibold text-md text-neutral-80 p-6">Pengaturan Tunjangan Representative</div>
            <div className="flex items-center justify-between px-6">
                <div className={"flex gap-3"}>
                    <FilterContainer
                        show={modal.filter}
                        onShow={() => onSetModal({filter: true})}
                        onClose={() => onSetModal({filter: false})}
                        optionsFilter={options}
                        queryFilter={queryFilter}
                        onSubmit={onChangeQuery}
                    />
                    <ViewList
                        show={modal?.sort}
                        onShow={() => onSetModal({sort: true})}
                        onClose={() => onSetModal({sort: false})}
                        value={query?.limit}
                        onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                    />
                </div>
                <Button title="Create Tunjangan Representative" icon={icAddSquare}
                        onClick={() => onActionRow({actionType: ACTION_TYPE.CREATE})}/>
            </div>
            <Table
                className="my-3"
                classNameHeader="first:!pl-6 last:!pr-6"
                classNameRow="first:!pl-6 last:!pr-6"
                name={configTable.name}
                data={dataBenefitRepresentative?.result}
                columns={configTable.column}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataBenefitRepresentative?.total_page}
                totalResult={dataBenefitRepresentative?.total_result}
                onChangePage={(page) => onChangeQuery({page})}
                onClickItem={onActionRow}
                loading={isLoadingTable}
            />
            <DeleteModal
                text="Apakah anda yakin ingin menghapus data tunjangan representative?"
                show={modal.delete}
                onHide={() => onSetModal({delete: false})}
                onDelete={onDelete}
                isLoading={isDeleting}
            />
            {
                modal?.form &&
                <FormModal
                    title={`${actionType === ACTION_TYPE.CREATE ? 'Create' : 'Update'} Tunjangan Representative`}
                    show={modal?.form}
                    width="max-w-[640px]"
                    contentClassName="overflow-auto"
                    onHide={() => onSetModal({form: false})}
                    isLoading={isCreating || isUpdating}
                    onSubmitForm={onSubmitForm}
                >
                    <div className={"flex flex-col space-y-5 px-8 py-6"}>
                        <div className="flex gap-3">
                            <div className="w-1/3 font-medium text-neutral-70 mt-2 required">Tipe Jam
                                Kerja
                            </div>
                            <div className="flex-1">
                                <Select
                                    name="schedule_category_id"
                                    className="flex-1"
                                    optionsClassName="max-h-40"
                                    placeholder="Pilih tipe jam kerja"
                                    options={options?.schedule_category}
                                    value={form?.schedule_category_id}
                                    onChange={onChangeForm}
                                />
                                <ErrorMessage className="mt-2"
                                              message={errorForm?.schedule_category_id}/>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="w-1/3 font-medium text-neutral-70 mt-2 required">Grade</div>
                            <div className="flex-1">
                                <Select
                                    name="grade_id"
                                    className="flex-1"
                                    optionsClassName="max-h-40"
                                    placeholder="Pilih grade"
                                    options={options?.grades}
                                    value={form?.grade_id}
                                    onChange={onChangeForm}
                                />
                                <ErrorMessage className="mt-2" message={errorForm?.grade_id}/>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="w-1/3 font-medium text-neutral-70 mt-2 required">Non DKI
                                Jakarta
                            </div>
                            <div className="flex-1">
                                <Input
                                    name="non_jakarta_based"
                                    className="flex-1"
                                    addonBefore="Rp"
                                    type="currency"
                                    value={form?.non_jakarta_based}
                                    onChange={onChangeForm}
                                />
                                <ErrorMessage className="mt-2"
                                              message={errorForm?.non_jakarta_based}/>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="w-1/3 font-medium text-neutral-70 mt-2 required">DKI
                                Jakarta
                            </div>
                            <div className="flex-1">
                                <Input
                                    name="jakarta_based"
                                    className="flex-1"
                                    addonBefore="Rp"
                                    type="currency"
                                    value={form?.jakarta_based}
                                    onChange={onChangeForm}
                                />
                                <ErrorMessage className="mt-2" message={errorForm?.jakarta_based}/>
                            </div>
                        </div>
                    </div>
                </FormModal>
            }
            <Toast
                show={isShowToast}
                message={toastMessage}
                onClose={() => clearToast()}
            />
        </>
    )
}
